import { useStore } from "@stores";
import { useEffect } from "react";

export const useLatestAnnouncements = (townId?: number) => {
  const { announcementStore } = useStore();

  useEffect(() => {
    announcementStore.getLatest({ townId, maxResultCount: 4, skipCount: 0 });
  }, [announcementStore, townId]);

  return {
    latest: announcementStore.latest,
    count: announcementStore.totalCount,
    loading: announcementStore.latestLoading,
  };
};
